import type { IntlShape } from 'react-intl';
import { SPACE_300 } from '@alltrails/denali/tokens';
import type { DynamicStyleId } from '@alltrails/maps/types/Styles';
import type { CustomRouteSegmentIndex } from '@alltrails/types/CustomRoute';

export const explorePath = '/explore';
export const getUserListsUrl = (userSlug: string) => `/members/${userSlug}/lists`;
export const sidebarId = 'explore-panel';
export const defaultDesktopMapPadding = {
  top: SPACE_300,
  bottom: SPACE_300,
  left: SPACE_300,
  right: SPACE_300
};
export const toolbarHeight = 60;
export const toastHeight = 58;

export const listMapSupportedDynamicStyleIds: DynamicStyleId[] = [
  'personalHeatmap',
  'newHeatmap',
  'trailHeatmap',
  'userWaypoints',
  'communityWaypoints',
  'nearbyTrails'
];

export const taskIdParam = 'taskId';

export const getCustomRouteDefaultName = (intl: IntlShape, trailName?: string) => {
  const prefix = intl.formatMessage({ defaultMessage: 'Custom route' });
  // The default route name should be "<default route name> — name of the trail"
  return trailName ? `${prefix} — ${trailName}` : prefix;
};

// What a segment is called when it has no name of its own. Segments are numbered from 1, so every list of them agrees on
// which one is "Segment 2" — including the placeholder in the field where a name gets typed.
export const getSegmentDefaultName = (intl: IntlShape, segmentIndex: CustomRouteSegmentIndex) =>
  intl.formatMessage({ defaultMessage: 'Segment {name}' }, { name: segmentIndex + 1 });
